import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

import { colors } from "@/theme/overrides/colors";

type Props = SvgIconProps;

const ScaleCircularIcon: React.FC<Props> = (props) => {
  return (
    <SvgIcon viewBox="0 0 37 37" {...props}>
      <rect
        x="1"
        y="1"
        width="35"
        height="35"
        rx="17.5"
        fill="white"
        stroke="#FF9D37"
        strokeWidth="2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5 9.92139C20.7635 9.92139 22.9118 10.3807 24.8841 11.2177C26.3931 11.8571 27.2789 13.4526 27.0396 15.097L25.5317 25.4848C25.3474 26.7565 24.2386 27.7157 22.9526 27.7157H14.0474C12.7614 27.7157 11.6526 26.7565 11.4683 25.4838L9.96036 15.097C9.72108 13.4526 10.6069 11.8571 12.1159 11.2177C14.0882 10.3807 16.2365 9.92139 18.5 9.92139ZM15.6842 16.5977C15.4653 16.6602 15.215 16.5664 15.1003 16.3683L13.4008 13.6157C13.3175 13.4801 13.2966 13.3133 13.3487 13.1673C13.4113 13.0214 13.5259 12.9066 13.6719 12.8441C16.6956 11.7806 20.303 11.7806 23.3267 12.8441C23.4727 12.9066 23.5874 13.0214 23.6499 13.1673C23.702 13.3133 23.6812 13.4802 23.5978 13.6157L21.8983 16.3682C21.8045 16.5247 21.6377 16.6185 21.4604 16.6185C21.395 16.6185 21.2853 16.5902 21.1233 16.5484C20.744 16.4506 20.0778 16.2787 19.0206 16.2223V14.648C19.0206 14.356 18.7913 14.1266 18.4993 14.1266C18.2073 14.1266 17.978 14.356 17.978 14.648V16.2223C17.196 16.264 16.4141 16.3892 15.6842 16.5977ZM23.8632 18.2972C24.0149 18.2972 24.1585 18.3634 24.2572 18.4774C24.357 18.5925 24.4008 18.7442 24.3794 18.8938L23.4671 25.1844C23.4295 25.44 23.2095 25.6304 22.9509 25.6304H14.0478C13.7891 25.6304 13.5692 25.44 13.5315 25.1844L12.6192 18.8938C12.5978 18.7442 12.6416 18.5925 12.7414 18.4774C12.8402 18.3633 12.9837 18.2972 13.1354 18.2972H23.8632Z"
        fill={colors.secondary}
      />
    </SvgIcon>
  );
};

export default ScaleCircularIcon;
